export default __webpack_public_path__ + "static/RobertBrady-e63e2c38b186f79cf602f9420d931fb9.jpg";